module.exports = __webpack_public_path__ + "static/assets/fb735d3c52484dfdc864f4066e212ad7.png";